<template>
  <div class="searchWithMultiSelect">
    <div
      @click="handleSearchBarFocus"
      @focusout="handleSearchBarBlur"
    >
      <InputSearch
        :placeholder="placeholderText"
        type="text"
        :value="searchText"
        @input="handleSearchBarInput"
      />
    </div>
    <MultiselectDropdown
      :canSelectAll="isSelectAllAllowed"
      :class="$style.searchMultiselectDropdown"
      :loading="loadingOptions"
      :open="open"
      :options="options"
      :totalOptions="totalOptions"
      :value="selectedOptions"
      @close="handleClose"
      @input="handleMultiSelectInput"
    />
    <div
      v-if="selectedOptions.length"
      :class="$style.selectedValuesChips"
    >
      <div
        v-for="filter in selectedOptions"
        :key="filter.value"
      >
        <ButtonDismissibleChip
          :ref="`chip-${filter.value}`"
          :text="filter.name"
          @click="() => handleFilterDelete(filter)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MultiselectDropdown from 'client/components/SearchWithMultiSelect/MultiselectDropdown.vue';

import {
  ButtonDismissibleChip,
  InputSearch,
} from '@jumpcloud/ui-components';

export default {
  name: 'SearchWithMultiSelect',

  components: {
    ButtonDismissibleChip,
    InputSearch,
    MultiselectDropdown,
  },

  model: {
    prop: 'selectedOptions',
    event: 'input',
  },

  props: {
    canSelectAll: Boolean,
    loadingOptions: Boolean,
    options: {
      type: Array,
      default: () => [],
    },
    placeholderText: {
      type: String,
      default: 'Search',
    },
    searchText: {
      type: String,
      default: '',
    },
    selectedOptions: {
      type: Array,
      default: () => [],
    },
    totalOptions: {
      type: Number,
      default: undefined,
    },
  },

  data: () => ({
    open: false,
    searchFocus: false,
    multiselectFocus: false,
  }),

  computed: {
    isSelectAllAllowed() {
      // don't allow select all on a filtered list
      return !this.searchBarText && this.canSelectAll;
    },

    searchBarText() {
      return this.open ? this.searchText : '';
    },
  },

  methods: {
    handleClose() {
      // Leave the selector open when the search is focused
      if (!this.searchFocus) {
        this.open = false;
      }
    },

    handleFilterDelete(item) {
      const newValue = this.selectedOptions.filter(val => val.value !== item.value);
      this.$emit('input', newValue);
    },

    handleMultiSelectInput(value) {
      this.$emit('input', value);
    },

    handleSearchBarBlur() {
      this.searchFocus = false;
    },

    handleSearchBarFocus() {
      if (!this.searchFocus && !this.open) {
        this.$emit('filter', '');
      }
      this.searchFocus = true;
      this.open = true;
    },

    handleSearchBarInput(value) {
      this.$emit('filter', value);
    },
  },
};
</script>

<style module>
.searchWithMultiSelect {
  position: relative;
  z-index: 1;
}

.searchMultiselectDropdown {
  width: 100%;
}

.selectedValuesChips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--jc-size-0p5);
  margin-top: var(--jc-spacer);
}
</style>
